import React, { useState } from "react";
import { BuilderComponent } from "@builder.io/react";
import classNames from "classnames";
import { builderIsEnabled } from "../../utils/general";
import { useRouter } from "../../utils/useRouter";

// Components
import FreeShippingBanner from "./FreeShippingBanner";
import Paragraph from "./Paragraph";
import Link from "./Link";

// Stylesheets
import "./Ribbon.scss";

const PAGES_TO_HIDE_FROM = ["/linkedin-wellness"];

export const Ribbon = ({ customRibbon, otherPagesToHideFrom = [] }) => {
  const [backgroundColor, setBackgroundColor] = useState("light-navy");
  const [hideRibbon, setHideRibbon] = useState(false);
  const {
    location: { pathname },
  } = useRouter();
  const pagesToHideFrom = [...PAGES_TO_HIDE_FROM, ...otherPagesToHideFrom];
  const hideFromCurrentPage = pagesToHideFrom.includes(pathname);

  if (builderIsEnabled()) {
    if (hideRibbon || hideFromCurrentPage) {
      return null;
    }

    const classes = classNames("ribbon", `ribbon_${backgroundColor}`);

    return (
      <div className={classes}>
        {customRibbon ? (
          <Paragraph className="body_secondary">
            Give Dad the gift of rest for Father's Day.{" "}
            <Link to="/restore">Shop Restore</Link>
          </Paragraph>
        ) : (
          <BuilderComponent
            model="ribbon"
            contentLoaded={(content) => {
              if (content) {
                setBackgroundColor(content.backgroundColor);
                setHideRibbon(content.hideRibbon);
              }
            }}
          />
        )}
      </div>
    );
  }

  return <FreeShippingBanner />;
};

export default Ribbon;
